
<mat-form-field  class="mat-form-field-flex dropdown" appearance="fill" >
  <mat-label *ngIf="isLabel">Select</mat-label>
  <ng-container *ngIf="!isMultiple">
    <mat-select
      style="position: relative; top: 2px"
      [(value)]="selected"
      (selectionChange)="selectionChanged($event)"
      [disabled]="disabled"
      panelClass="commondropdown"
    >
      <mat-option
        [disabled]="value?.disableOption"
        *ngFor="let value of dropdownData"
        [value]="value"
      >
        <span *ngIf="type == 'string'">{{ value }}</span>
        <span *ngIf="type == 'object'">{{ value[displayMember] }}</span>
        <span *ngIf="type == 'multiplekey'">{{ value["customDisplay"] }}</span>
      </mat-option>
    </mat-select>
  </ng-container>
  <ng-container *ngIf="isMultiple">
    <mat-select
      [(value)]="selected"
      (selectionChange)="selectionChanged($event)"
      [disabled]="disabled"
      multiple
      panelClass="commondropdown"
    >
      <mat-option *ngFor="let value of dropdownData" [value]="value"  [disabled]="value?.disableOption">
        <span *ngIf="type == 'string'">{{ value }}</span>
        <span *ngIf="type == 'object'">{{ value[displayMember] }}</span>
        <span *ngIf="type == 'multiplekey'">{{ value["customDisplay"] }}</span>
      </mat-option>
    </mat-select>
  </ng-container>
</mat-form-field>
